import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectHomeData, selectHomeStatus, selectHomeError, initializeAsync } from "./homeSlice";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Header } from "./Header";
import Box from "@mui/material/Box";
import { ArtCollection } from "../../components/ArtCollection";
import { useAuth } from "../../hooks/useAuth";
import { get, post } from "../../api";
import { useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { query } from "../../services/object";
import { Backdrop, CircularProgress } from "@mui/material";

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
let timer;
const Home = (props) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const enableFavorite = urlParams.get("enableFavorite");
    let title = "STUDENT COLLECTION";
    let page = "Student";
    let enableFavourite = props.enableFavourite;
    let insideApplication = props.insideApplication;
    const data = useSelector(selectHomeData);
    const status = useSelector(selectHomeStatus);
    const error = useSelector(selectHomeError);
    const location = useLocation();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const dispatch = useDispatch();

    const [itemData, setItemData] = useState();
    const [hasImages, setHasImages] = useState(true);
    const [favouriteCount, setFavouriteCount] = useState(0);
    const [switchSatus, setSwitchStatus] = useState(false);
    const [selectedItem, setSelectedItem] = useState({
        featured: localStorage.getItem("sorting") ? localStorage.getItem("sorting") : "",
        grade: "",
        year: "",
        color: [],
        style: [],
        keyword: "",
        favourite: enableFavorite === "true" ? true : false,
    });
    const [mapFavouriteArts, setMapFavouriteArts] = useState({});

    const photosRef = useRef([]);
    const hasMoreRef = useRef(true);
    const lastKeyRef = useRef();
    const lastIndexRef = useRef();
    const [loading, setLoading] = useState(true);
    const [noRecordFound, setNoRecordFound] = useState(false);

    const savingFavorite = useRef([]);
    savingFavorite.current = [];

    const currentFavorite = useRef([]);
    currentFavorite.current = [];

    const initiatedCallRef = useRef(false);

    useEffect(() => {
        if (enableFavourite) {
            getFavoritesArts();
        }
        loadData("", selectedItem);
    }, [location.pathname]);

    const loadData = (lastKey, filters) => {
        if (hasMoreRef.current && !initiatedCallRef.current) {
            initiatedCallRef.current = true;
            setNoRecordFound(false);
            post("art/getAllArtRecords", {
                lastKey: lastKey,
                filters: filters,
                enableFavourite: enableFavourite,
                accountId: userDetails?.contact?.accountId,
                caching: filters?.featured === "Randomize" ? "no" : "yes",
                lastIndex: lastKey ? lastIndexRef.current : "",
            }).then((result) => {
                if (result.isSuccess) {
                    processData(result.data.records);
                    if (result.data.lastKey) {
                        hasMoreRef.current = true;
                        lastKeyRef.current = result.data.lastKey;
                        lastIndexRef.current = result.data.lastIndex;
                    } else {
                        hasMoreRef.current = false;
                    }
                    if (photosRef.current?.length === 0) {
                        setNoRecordFound(true);
                    }
                }
                if (loading) {
                    setLoading(false);
                }
                initiatedCallRef.current = false;
            });
        }
    };

    const processData = (data) => {
        if (data.length > 0) {
            let images = data;
            //photosRef.current = [...photosRef.current, ...images];
            photosRef.current = photosRef.current.concat(images);
            setItemData([...photosRef.current, ...images]);
            setHasImages(true);
        }
    };

    // useEffect(() => {
    //     if (status === "idle") {
    //         dispatch(initializeAsync());
    //     } else {
    //     }
    // }, [status, dispatch, mapFavouriteArts]);

    const getFavoritesArts = async () => {
        if (userDetails?.contact?.accountId && userDetails?.contact?.id) {
            let result = await get("favourite/getFavourite", {
                accountId: userDetails?.contact?.accountId,
                contactId: userDetails?.contact?.id,
                getArtDetails: "no",
            });

            if (result.isSuccess && result.data) {
                let mapFavourite = {};
                for (let record of result.data) {
                    mapFavourite[record.artId] = record;
                }
                setMapFavouriteArts(mapFavourite);
                setFavouriteCount(result.data.length);
                if (enableFavorite === "true")
                    post("art/getAllArtRecords", {
                        lastKey: "",
                        filters: selectedItem,
                        enableFavourite: enableFavourite,
                        accountId: userDetails?.contact?.accountId,
                        caching: selectedItem?.featured === "Randomize" ? "no" : "yes",
                        limit: result.data?.length,
                    }).then((result) => {
                        if (result.isSuccess) {
                            processData(result.data.records);
                            if (result.data.lastKey) {
                                hasMoreRef.current = true;
                                lastKeyRef.current = result.data.lastKey;
                                lastIndexRef.current = result.data.lastIndex;
                            } else {
                                hasMoreRef.current = false;
                            }
                            if (photosRef.current?.length === 0) {
                                setNoRecordFound(true);
                            }
                        }
                        if (loading) {
                            setLoading(false);
                        }
                        initiatedCallRef.current = false;
                    });
            }
        }
    };

    const handleClear = (event) => {
        setSelectedItem({
            featured: "",
            grade: "",
            year: "",
            color: [],
            style: [],
            keyword: [],
        });
        photosRef.current = [...itemData];
    };

    const handleFilterData = (select) => {
        const attr = select?.id;
        let selected;
        if (attr === "year") {
            selected = {
                ...selectedItem,
                year: select?.value,
            };
        } else if (attr === "grade") {
            selected = {
                ...selectedItem,
                grade: select?.value,
            };
        } else if (attr === "style/medium") {
            selected = {
                ...selectedItem,
                style: select?.value,
            };
        } else if (attr === "color") {
            selected = {
                ...selectedItem,
                color: select?.value,
            };
        } else if (attr === "featured") {
            selected = {
                ...selectedItem,
                featured: select?.value,
            };
            localStorage.setItem("sorting", select.value);
        } else if (attr === "keyword") {
            selected = {
                ...selectedItem,
                keyword: select?.value,
            };
        } else if (attr === "favourite") {
            setSwitchStatus(select?.value);
            selected = {
                ...selectedItem,
                favourite: select?.value,
            };
        }
        setSelectedItem(selected);
        photosRef.current = [];
        setItemData([]);
        hasMoreRef.current = true;
        lastKeyRef.current = undefined;

        if (attr === "keyword") {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(() => {
                loadData("", selected);
            }, 1100);
        } else {
            loadData("", selected);
        }
    };

    const handleDeleteFavourite = async (item) => {
        let images = photosRef.current;
        if (item.favoriteDetail) {
            let favoriteDetail = item.favoriteDetail;
            images = images?.map((record) => {
                if (record.id === item.id) {
                    record.hasFavorites = false;
                    record.favoriteDetail = undefined;
                }
                return record;
            });
            if (selectedItem.favourite) {
                images = images.filter((item) => item.hasFavorites);
            }
            photosRef.current = [...images];
            setFavouriteCount(favouriteCount - 1);
            await post("favourite/removeFavourite", favoriteDetail).then((result) => {
                if (result.isSuccess) {
                    images = images?.map((record) => {
                        if (record.id === item.id) {
                            record.hasFavorites = false;
                            record.favoriteDetail = undefined;
                        }
                        return record;
                    });
                    photosRef.current = [...images];
                }
            });
            post("favourite/removeFavouriteToBackend", {
                artId: item.id,
                artName: item.title,
                contactId: userDetails.contact.id,
                accountId: userDetails.contact.accountId,
            }).then((result) => {});
        }
        setItemData([...photosRef.current, ...images]);
    };

    const handleFavourite = async (item) => {
        const userDetails = getUserDetailsNotAsync();
        let images = photosRef.current;
        if (savingFavorite.current.indexOf(item.id) === -1) {
            console.log("savingFavorite.current", savingFavorite.current);
            savingFavorite.current = [...savingFavorite.current, item.id];
            if (!item.favoriteDetail) {
                setFavouriteCount(favouriteCount + 1);
                await post("favourite/markFavourite", {
                    artId: item.id,
                    contactName: userDetails.contact.name,
                    contactId: userDetails.contact.id,
                    accountId: userDetails.contact.accountId,
                    accountName: userDetails.contact.accountName,
                }).then((result) => {
                    if (result.isSuccess) {
                        images = images?.map((record) => {
                            if (record.id === item.id) {
                                record.hasFavorites = true;
                                record.favoriteDetail = result.data;
                            }
                            return record;
                        });
                        photosRef.current = [...images];
                    }
                });
                post("favourite/markFavouriteToBackend", {
                    artId: item.id,
                    artName: item.title,
                    contactId: userDetails.contact.id,
                    accountId: userDetails.contact.accountId,
                }).then((result) => {});
            }

            setItemData([...photosRef.current, ...images]);
            savingFavorite.current = savingFavorite.current.filter((record) => record !== item.id);
        }
    };

    const fetchData = () => {
        loadData(lastKeyRef.current, selectedItem);
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <Container
                sx={{
                    background: enableFavourite ? "#303030" : "black",
                    minHeight: "100vh",
                }}
                maxWidth={false}
                disableGutters>
                <Header
                    title="Gallery"
                    favouriteCount={favouriteCount}
                    onChange={handleFilterData}
                    selectedItems={{ ...selectedItem }}
                    onClear={handleClear}
                    enableFavourite={enableFavourite}
                    insideApplication={insideApplication}
                />
                <main>
                    <Box
                        sx={{
                            bgcolor: enableFavourite ? "#303030" : "#000",
                            m: "0px auto",
                        }}>
                        {hasImages ? (
                            <div id="scrollableDiv" style={{ height: "100vh", overflow: "auto" }}>
                                <InfiniteScroll
                                    dataLength={photosRef.current.length} //This is important field to render the next data
                                    next={fetchData}
                                    hasMore={true}
                                    loader={
                                        <>
                                            {false ? (
                                                <h4
                                                    style={{
                                                        position: "absolute",
                                                        bottom: "0",
                                                        width: "100%",
                                                        color: "white",
                                                    }}>
                                                    Loading...
                                                </h4>
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    }
                                    height={"100vh"}
                                    endMessage={<p></p>}>
                                    <ArtCollection
                                        enableFavourite={enableFavourite}
                                        page={page}
                                        title={enableFavourite ? "" : title}
                                        photos={photosRef.current}
                                        noRecordFound={noRecordFound}
                                        subtitle={
                                            enableFavourite ? (
                                                <></>
                                            ) : (
                                                <>
                                                    A curated gallery of{" "}
                                                    <span
                                                        style={{
                                                            fontFamily: "Stakkat, sans-serif",
                                                            fontStyle: "italic",
                                                        }}>
                                                        thousands of beautiful artwork pieces
                                                    </span>{" "}
                                                    donated from generous K-12 student artists.
                                                </>
                                            )
                                        }
                                        onClick={handleFavourite}
                                        onDelete={handleDeleteFavourite}></ArtCollection>
                                </InfiniteScroll>
                            </div>
                        ) : (
                            ""
                        )}
                    </Box>
                    {/* <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop> */}
                </main>
            </Container>
        </ThemeProvider>
    );
};

export { Home };
